import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { EnumSpinnerLoaderPosition, SpinnerLoader, variantActionsProps } from 'shared/ui'
import { Table } from 'shared/ui/TableNew'
import { NoResultsFound } from 'shared/ui/NoResultsFound/NoResultsFound'
import { type IRowBroadcast } from 'entities/Broadcast'
import { BroadcastsRoutes } from 'entities/ExportRouters'
import { useEventBroadcastCanceled } from 'entities/Broadcast/events/EventBroadcastCanceled'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useBroadcastsListContext } from 'pages/broadcasts/ui/BroacastList/context'
import { getBroadcastActions } from 'pages/broadcasts/ui/BroadcastActions'
import {
  getColumnsCombo,
  getColumnsOneTime,
} from 'pages/broadcasts/ui/BroacastList/ui/BroadcastTable/getColumns'
import styles from './styles.module.scss'

export const BroadcastsTable = observer(() => {
  const { type, itemsRows, onUpdateItem, loading, tableStore, onDelete } =
    useBroadcastsListContext()
  const entities = useEntitiesContext()

  const getRowLink = (row: IRowBroadcast) =>
    `/${BroadcastsRoutes.root}/${
      row.status === 'draft' || row.status === 'scheduled'
        ? BroadcastsRoutes.edit
        : BroadcastsRoutes.view
    }/${row.id}`

  useEventBroadcastCanceled(onUpdateItem)

  const rows = useMemo(() => {
    return itemsRows.map((item) => {
      item.setActionsProps({
        ...variantActionsProps.table,
        actions: getBroadcastActions({
          broadcast: item.origin,
          onSuccessDelete: () => onDelete([item.id]),
        }),
      })

      return item
    })
  }, [itemsRows, type])

  if (loading) {
    return (
      <SpinnerLoader ariaLabel={'BroadcastsTable'} position={EnumSpinnerLoaderPosition.Absolute} />
    )
  }

  if (!itemsRows.length) {
    return <NoResultsFound />
  }

  return (
    <div className={styles.wrap}>
      <Table
        ariaLabel={'BroadcastsTable'}
        store={tableStore}
        emptyStateProps={{
          text: 'No broadcasts found',
          noIcon: true,
        }}
        columns={getColumnsCombo(type, entities)}
        columnsChild={getColumnsOneTime(type, entities)}
        pinnedColumnIds={['expandedColumn', 'name']}
        hideExpandColumnsIds={['type']}
        rows={rows}
        getRowLink={getRowLink}
      />
    </div>
  )
})
